import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// console.log('API URL:', API_URL); 

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para añadir el token a las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Verificar si es una ruta pública (no requiere autenticación)
    const isPublicRoute = error.config?.url?.includes('/profiles/') && 
                          !error.config?.url?.includes('/me');
    
    // Solo redirigir si es error 401 y NO es ruta pública
    if (error.response?.status === 401 && !isPublicRoute) {
      console.log('🔒 Sesión expirada, redirigiendo a login');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);


// Servicios específicos para el dashboard
export const dashboardService = {
  // Links
  getLinks: () => api.get('/links'),
  saveLinks: (links) => api.post('/links/save-all', { links }),
  
  // Perfil
  getProfile: () => api.get('/profiles/me'),
  updateProfile: (profileData) => api.put('/profiles/me', profileData),

  // Imágenes de perfil (Cloudinary)
  uploadAvatar: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return api.post('/profiles/me/avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  removeAvatar: () => api.delete('/profiles/me/avatar'),
  uploadBanner: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return api.post('/profiles/me/banner', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  removeBanner: () => api.delete('/profiles/me/banner'),

  // Obtener todo junto (para carga inicial)
  getDashboardData: async () => {
    const [linksRes, profileRes] = await Promise.all([
      api.get('/links'),
      api.get('/profiles/me')
    ]);
    return {
      links: linksRes.data.data,
      profile: profileRes.data.data.profile,
      planInfo: profileRes.data.data.planOfProfile
    };
  }
};


export const onboardingService = {
  /**
   * Verifica si un username está disponible
   * @param {string} username - Nombre de usuario a verificar
   * @returns {Promise<{available: boolean}>}
   */
  checkUsername: (username) => api.post('/users/check-username', { username }),
  
  /**
   * Completa el proceso de onboarding
   * @param {Object} data - Datos del onboarding
   * @param {string} data.username - Nombre de usuario elegido
   * @param {string} data.displayName - Nombre a mostrar
   * @returns {Promise<{success: boolean}>}
   */
  completeOnboarding: (data) => api.post('/users/complete-onboarding', data),
  
  /**
   * Actualiza el username del usuario
   * @param {string} username - Nuevo nombre de usuario
   * @returns {Promise<{success: boolean, user: Object}>}
   */
  updateUsername: (username) => api.put('/users/username', { username }),
  
  /**
   * Obtiene sugerencias de username basadas en el nombre
   * @param {string} baseName - Nombre base para sugerencias
   * @returns {Promise<{suggestions: string[]}>}
   */
  getUsernameSuggestions: (baseName) => api.get(`/users/username-suggestions?base=${baseName}`)
};